export const DEFAULT_IMAGE = '/assets/images/default.png';
